<template>

  <div class="imei-history">
     <KTCodePreview v-bind:title="'Lịch sử IMEI'"
      > <template v-slot:preview
        > <b-row class="mb-5"
          > <b-col md="3"
            > <b-input
              size="sm"
              placeholder="Nhập mã IMEI"
              v-model="searchIMEI"
              v-on:keyup.enter="onFilter()"
            ></b-input
            > </b-col
          > <b-col md="3"
            > <b-input
              size="sm"
              placeholder="Nhập mã, tên sản phẩm"
              v-model="searchProduct"
              v-on:keyup.enter="onFilter()"
            ></b-input
            > </b-col
          > <b-col md="3"
            >
            <div class="search-col">
               <b-input-group
                > <date-picker
                  placeholder="Từ"
                  class="form-control form-control-sm"
                  :config="dpConfigs.date"
                  v-model="searchFromDay"
                ></date-picker
                > </b-input-group
              > <span class="ml-1 mr-1"></span> <b-input-group
                > <date-picker
                  placeholder="Đến"
                  class="form-control form-control-sm"
                  :config="dpConfigs.date"
                  v-model="searchToDay"
                ></date-picker
                > </b-input-group
              >
            </div>
             </b-col
          > <b-col md="3"
            > <b-form-select
              class="select-style"
              size="sm"
              v-model="selectedAction"
              :options="listAction"
              value-field="id"
              text-field="name"
              v-on:change="fetchData"
            ></b-form-select
            > </b-col
          > </b-row
        > <b-row class="mb-5"
          > <b-col md="1"
            > <b-button
              style="fontweight: 600; width: 70px"
              variant="primary"
              size="sm"
              @click="onFilter"
              >Lọc</b-button
            > </b-col
          > </b-row
        > <b-table
          :items="listImeis"
          :fields="fields"
          :bordered="true"
          :hover="true"
          :busy="onLoading"
          > <template v-slot:table-busy
            > <vcl-table
              :speed="5"
              :animate="true"
              :columns="10"
            ></vcl-table
            > </template
          > <template v-slot:cell(action)="row"
            > <span v-text="row.item.action"></span> <br />
            <div class="store-names">
               <span
                v-if="row.item.storeName"
                class="store-name store-name-source"
                v-text="row.item.storeName"
              ></span
              > <span
                v-if="row.item.storeName && row.item.destinationStoreName"
                class="store-separator"
                > → </span
              > <span
                v-if="row.item.destinationStoreName"
                class="store-name store-name-destination"
                v-text="row.item.destinationStoreName"
              ></span
              >
            </div>
             </template
          > <template v-slot:cell(productName)="row"
            > <ProductCommonInfo :product="row.item" /> </template
          > <template v-slot:cell(stockSlipCode)="row"
            >
            <div
              class="d-flex justify-content-center"
              :class="{ billCode: isDocumentClickable(row.item) }"
              :style="isDocumentClickable(row.item) ? { cursor: 'pointer' } : null"
              @click="openDocumentLink(row.item)"
            >
               <span v-text="getDocumentLabel(row.item)"></span>
            </div>
             </template
          > <template v-slot:cell(stockSlipDescription)="row"
            >
            <div
              v-if="row.item.stockSlipDescription"
              class="stock-slip-description text-left"
              v-b-tooltip.hover
              :title="row.item.stockSlipDescription"
            >
              {{ formatStockSlipDescription(row.item.stockSlipDescription) }}
            </div>
            <span v-else class="text-muted">—</span>
             </template
          > <template v-slot:cell(createdBy)="row"
            >
            <div class="text-center">
              <span v-text="row.item.createdBy || '—'"></span>
              <div
                v-if="row.item.saleName && row.item.saleName !== row.item.createdBy"
                class="text-muted small mt-1"
              >
                NV: {{ row.item.saleName }}
              </div>
            </div>
             </template
          > <template v-slot:cell(imeiCode)="row"
            >
            <div class="d-flex align-items-center gap-2">

              <div
                class="billCode flex-grow-1"
                @click="linkToImei(row.item)"
                style="cursor: pointer"
              >
                 <span v-text="row.item.imeiCode"></span>
              </div>
               <b-button
                variant="link"
                class="p-0 copy-imei-btn"
                @click.stop="copyImeiToClipboard(row.item.imeiCode)"
                v-b-tooltip.hover
                title="Copy IMEI"
                style="min-width: auto; padding: 0 4px !important"
                > <i
                  class="fas fa-copy text-primary"
                  style="font-size: 0.875rem"
                ></i
                > </b-button
              > <span
                v-if="row.item.companyCode"
                class="badge badge-pill company-code-badge"
                :style="{
                  backgroundColor: getCompanyCodeColor(row.item.companyCode),
                  color: '#fff',
                }"
                > {{ row.item.companyCode }} </span
              >
            </div>
             </template
          > <template v-slot:cell(createdAt)="row"
            > <span v-text="row.item.createdAt"></span> </template
          > </b-table
        > <b-row
          > <b-col
            >
            <p
              class="mt-3 text-dark"
              style="font-weight: 500"
            >
               Tổng số: {{ convertPrice(totalItem) }}
            </p>
             </b-col
          >
          <div class="d-flex justify-content-end">
             <b-col
              > <b-pagination-nav
                class="custom-pagination"
                v-if="numberOfPage >= 2"
                :link-gen="linkGen"
                :number-of-pages="numberOfPage"
                use-router
                @change="fetchData"
                align="right"
                first-class="page-item-first btn btn-icon m-1 btn-sm"
                prev-class="page-item-prev btn btn-icon m-1 btn-sm"
                next-class="page-item-next btn btn-icon btn-sm m-1 "
                last-class="page-item-last btn btn-icon btn-sm m-1"
                page-class="btn btn-icon btn-sm border-0 m-1"
                > <template v-slot:first-text
                  > <span> <i class="ki ki-double-arrow-back icon-xs"></i> </span> </template
                > <template v-slot:prev-text> <i class="ki ki-arrow-back icon-xs"></i> </template>
                <template v-slot:next-text> <i class="ki ki-arrow-next icon-xs"></i> </template>
                <template v-slot:last-text
                  > <span class="text-info"> <i class="ki ki-double-arrow-next icon-xs"></i> </span>
                  </template
                > </b-pagination-nav
              > </b-col
            >
          </div>
           </b-row
        > </template
      > </KTCodePreview
    >
    <AutoStockSlipViewModal
      :visible.sync="showAutoStockSlipViewModal"
      :slip-id="autoStockSlipViewSlipId"
      :slip-type="autoStockSlipViewSlipType"
      :direction="autoStockSlipViewDirection"
    />
  </div>
</template>

<style lang="scss">
  .imei-history {
  .labelInput {
    font-weight: 600;
  }

  .productCode:hover {
    text-decoration: underline;
  }

  .page-item.disabled {
    cursor: not-allowed;

    &.bv-d-xs-down-none {
      .page-link {
        margin: 0.35rem 0.25rem;
        text-align: center;
      }
    }
  }

  .icon:hover {
    background-color: #90c6fc;
  }

  .table th,
  .table td {
    padding: 0.75rem;
    vertical-align: middle;
    border-top: 1px solid #ecf0f3;
  }

  .table.b-table.table-sm
    > thead
    > tr
    > [aria-sort]:not(.b-table-sort-icon-left),
  .table.b-table.table-sm
    > tfoot
    > tr
    > [aria-sort]:not(.b-table-sort-icon-left) {
    background-position: right calc(1.5rem / 2) center;
    padding-right: calc(0.3rem + 0.65em);
  }

  .billCode:hover {
    text-decoration: underline;
    color: blue($color: #000000);
  }

  .company-code-badge {
    font-size: 0.7rem;
    font-weight: 600;
    padding: 0.4rem 0.7rem;
    letter-spacing: 0.3px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12);
    transition: all 0.2s ease;
    white-space: nowrap;
    display: inline-flex;
    align-items: center;
    line-height: 1;
    flex-shrink: 0;
  }

  .company-code-badge:hover {
    transform: translateY(-1px);
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.18);
  }

  // Hỗ trợ gap cho các trình duyệt không hỗ trợ
  .d-flex.gap-2 > * + * {
    margin-left: 0.5rem;
  }

  .search-col {
    display: flex;
    align-items: center;
  }

  .store-names {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 0.25rem;
  }

  .store-name {
    font-weight: 500;
  }

  .store-name-source {
    color: #007bff;
  }

  .store-name-destination {
    color: #28a745;
  }

  .store-separator {
    color: #6c757d;
    font-weight: 600;
    margin: 0 0.25rem;
  }

  .stock-slip-description {
    font-size: 0.8125rem;
    line-height: 1.4;
    color: #3f4254;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;
    word-break: break-word;
    white-space: pre-line;
  }
}
</style>

<script>
  import KTCodePreview from '@/view/content/CodePreview.vue'
  import { SET_BREADCRUMB } from '@/core/services/store/modules/breadcrumbs.module'
  import ApiService from '@/core/services/api.service'
  import localData from '../../../utils/saveDataToLocal'
  import { VclTable } from 'vue-content-loading'
  import decounce from 'debounce'
  import moment from 'moment'
  import ProductCommonInfo from '@/view/components/products/ProductCommonInfo.vue'
  import { getCompanyCodeColor, makeToastSuccess, makeToastFaile } from '@/utils/common'
  import {
    resolveImeiHistoryDocument,
  } from '@/utils/imeiHistoryDocument'
  import autoStockSlipViewModalMixin from '@/view/mixins/auto-stock-slip-view-modal.mixin'

  export default {
    mixins: [autoStockSlipViewModalMixin],
    data() {
      return {
        selectedProduct: '',
        fields: [
          {
            key: 'count',
            label: 'STT',
            thStyle: { textAlign: 'center', width: '5%' },
            tdClass: 'text-center',
          },
          {
            key: 'action',
            label: 'Hành động',
            sortable: false,
            thStyle: {
              textAlign: 'center',
              color: 'rgb(24, 28, 50)',
              width: '15%',
            },
          },
          {
            key: 'stockSlipCode',
            label: 'Mã phiếu',
            sortable: false,
            thStyle: {
              textAlign: 'center',
              color: 'rgb(24, 28, 50)',
              width: '10%',
            },
          },
          {
            key: 'stockSlipDescription',
            label: 'Diễn giải phiếu',
            sortable: false,
            thStyle: {
              textAlign: 'center',
              color: 'rgb(24, 28, 50)',
              width: '15%',
            },
          },
          {
            key: 'imeiCode',
            label: 'IMEI',
            sortable: false,
            thStyle: {
              textAlign: 'center',
              color: 'rgb(24, 28, 50)',
              width: '20%',
            },
          },
          {
            key: 'productName',
            label: 'Sản phẩm',
            sortable: false,
            thStyle: {
              textAlign: 'center',
              color: 'rgb(24, 28, 50)',
              width: '20%',
            },
          },
          {
            key: 'createdBy',
            label: 'Người thao tác',
            thStyle: {
              textAlign: 'center',
              color: 'rgb(24, 28, 50)',
              width: '15%',
            },
            tdClass: 'width: 15%',
          },
             {
            key: 'note',
            label: 'Ghi chú',
            thStyle: {
              textAlign: 'center',
              color: 'rgb(24, 28, 50)',
              width: '15%',
            },
            tdClass: 'width: 10%',
          },
          {
            key: 'createdAt',
            label: 'Ngày tạo',
            thStyle: {
              textAlign: 'center',
              color: 'rgb(24, 28, 50)',
              width: '10%',
            },
            tdClass: 'width: 15%',
          },
        ],
        searchIMEI: '',
        listImeis: [],
        linkGen: (pageNum) => {
          return pageNum === 1 ? '?' : `?page=${pageNum}`
        },
        page: 1,
        totalItem: 0,
        selectedAction: null,
        listAction: [
          { id: null, name: 'Tất cả hành động' },
          { id: 1, name: 'Nhập kho' },
          { id: 2, name: 'Xuất kho' },
          { id: 3, name: 'Chuyển kho' },
          { id: 4, name: 'Cập nhật phiếu nhập kho' },
          { id: 5, name: 'Cập nhật phiếu xuất kho' },
          { id: 6, name: 'Xuất chuyển kho' },
          { id: 7, name: 'Nhập chuyển kho' },
          { id: 8, name: 'Xuất kho bán lẻ' },
          { id: 9, name: 'Xuất kho bán buôn' },
          { id: 10, name: 'Nhập từ phiếu trả hàng' },
          { id: 11, name: 'Nhập kho từ đơn chuyển hoàn' },
          { id: 12, name: 'Xuất kho giao hàng' },
          { id: 13, name: 'Cân kho' },
          { id: 14, name: 'Nhập kho bảo hành' },
          { id: 15, name: 'Cập nhật nhập kho bảo hành' },
          { id: 16, name: 'Xuất kho bảo hành' },
          { id: 17, name: 'Cập nhật xuất kho bảo hành' },
          { id: 18, name: 'Đổi sản phẩm' },
          { id: 19, name: 'Xóa sản phẩm trong hóa đơn' },
          { id: 20, name: 'Xóa hóa đơn' },
          { id: 21, name: 'Xóa hóa đơn trả hàng' },
          { id: 22, name: 'Cập nhật hóa đơn' },
          { id: 23, name: 'Xóa phiếu chuyển kho' },
          { id: 24, name: 'Xóa phiếu nhập' },
          { id: 25, name: 'Xóa phiếu nhập' },
          { id: 26, name: 'Nhập thu cũ' },
          { id: 27, name: 'Hủy phiếu chuyển' },
          { id: 28, name: 'Nhập giữ hàng' },
          { id: 29, name: 'Cập nhật phiếu giữ hàng' },
          { id: 30, name: 'Xóa phiếu giữ hàng' },
          { id: 31, name: 'Xuất trả giữ hàng' },
          { id: 32, name: 'Xóa phiếu trả giữ hàng' },
          { id: 33, name: 'Hủy phiếu giữ hàng' },
          { id: 34, name: 'Nhập kho từ phiếu kiểm tồn kho' },
          { id: 35, name: 'Xuất kho từ phiếu kiểm tồn kho' },
          { id: 76, name: 'Đang tiếp nhận bảo hành' },
          { id: 77, name: 'Đang sửa bảo hành' },
          { id: 78, name: 'Đã sửa bảo hành' },
          { id: 79, name: 'Hoàn thành bảo hành' },
          { id: 80, name: 'Đã trả bảo hành' },
        ],
        onLoading: false,
        numberOfPage: 0,
        searchProduct: '',
        dpConfigs: {
          date: {
            format: 'DD/MM/YYYY',
            useCurrent: false,
            showClear: true,
            showClose: true,
            minDate: false,
            maxDate: false,
            locale: 'vi',
            sideBySide: true,
          },
        },
        searchFromDay: '',
        searchToDay: '',
      }
    },
    components: {
      KTCodePreview,
      VclTable,
      ProductCommonInfo,
    },
    mounted() {
      this.$store.dispatch(SET_BREADCRUMB, [
        { title: 'IMEI', route: '/imei-histories' },
        { title: 'Lịch sử IMEI' },
      ])
    },
    created() {
      let imeiCode = this.$route.query.code
      if (imeiCode !== undefined) {
        this.searchIMEI = imeiCode
      }
      this.fetchData()
    },
    methods: {
      getCompanyCodeColor,
      convertPrice: function (number) {
        if (!number) return 0
        return new Intl.NumberFormat('vn-VN').format(number)
      },
      fetchData: function () {
        this.onLoading = true
        this.page = this.$route.query.page ? this.$route.query.page : 1

        const param = {
          page: this.page,
          limit: 10,
          action: this.selectedAction,
          searchIMEI: this.searchIMEI,
          searchProduct: this.searchProduct,
          fromDate: this.searchFromDay
            ? moment(this.searchFromDay, 'DD/MM/YYYY').format('yyyy-MM-DD 00:00:00')
            : null,
          toDate: this.searchToDay
            ? moment(this.searchToDay, 'DD/MM/YYYY').format('yyyy-MM-DD 23:59:59')
            : null,
        }

        const paramQuery = {
          params: param,
        }

        ApiService.query('v1/imei-histories', paramQuery)
          .then(({ data }) => {
            this.listImeis = []
            this.numberOfPage = data.data.totalPage
            this.totalItem = data.data.totalRow
            const dataResponse = data.data.data
            let result = []
            dataResponse.forEach((item, index) => {
              let stock = {
                ...item,
                count: this.currentPage >= 2 ? index + 1 + this.currentPage * 10 - 10 : index + 1,
                createdAt: moment(item.createdAt).format('HH:mm:ss DD/MM/YYYY'),
              }
              result.push(stock)
              this.listImeis = [...new Set(result)]
            })
            this.onLoading = false
          })
          .catch(() => {
            this.onLoading = false
          })
      },
      editItem: function (item) {
        this.$router.push({
          path: 'imeis/update-imei',
          query: { id: item.id },
        })
      },
      checkPermission: function (condition) {
        return localData.checkPermission(condition)
      },
      getDocumentLabel(item) {
        return resolveImeiHistoryDocument(item).label
      },
      formatStockSlipDescription(text) {
        if (!text) return ''
        const normalized = String(text).replace(/\s+/g, ' ').trim()
        if (normalized.length <= 80) {
          return normalized
        }
        return `${normalized.slice(0, 80)}…`
      },
      isDocumentClickable(item) {
        return resolveImeiHistoryDocument(item).clickable
      },
      openDocumentLink(item) {
        this.openImeiHistoryDocumentLink(item)
      },
      linkToImei: function (item) {
        const { href } = this.$router.resolve({
          name: 'list-imeis',
          query: { code: item.imeiCode },
        })
        window.open(href, '_blank')
      },
      copyImeiToClipboard: async function (imeiCode) {
        try {
          if (navigator.clipboard && navigator.clipboard.writeText) {
            await navigator.clipboard.writeText(imeiCode)
            makeToastSuccess('Đã copy IMEI: ' + imeiCode)
          } else {
            // Fallback for older browsers
            const textArea = document.createElement('textarea')
            textArea.value = imeiCode
            textArea.style.position = 'fixed'
            textArea.style.left = '-999999px'
            document.body.appendChild(textArea)
            textArea.select()
            document.execCommand('copy')
            document.body.removeChild(textArea)
            makeToastSuccess('Đã copy IMEI: ' + imeiCode)
          }
        } catch (err) {
          makeToastFaile('Không thể copy IMEI')
        }
      },
      debounceInput: decounce(function () {
        this.fetchData()
      }, 2000),
      onFilter() {
        this.$route.query.page = 1
        this.$router.push({
          name: 'list-imei-history',
        })
        this.fetchData()
      },
    },
  }
</script>

